module.exports = __webpack_public_path__ + "static/media/testing.b6849892.svg";